import { ActionPermissionStatus } from '../../models/actionPermission';

const toOption = (status: ActionPermissionStatus) => ({
  key: status,
  value: `actionPermissions.statuses.${status}`,
});

export const ACTION_PERMISSION_STATUS_OPTIONS = Object.values(ActionPermissionStatus).map(toOption);

const EDITABLE_STATUSES = [
  ActionPermissionStatus.Waiting,
  ActionPermissionStatus.Approve,
  ActionPermissionStatus.Used,
  ActionPermissionStatus.Cancelled,
];

export const EDITABLE_ACTION_PERMISSION_STATUS_OPTIONS = EDITABLE_STATUSES.map(toOption);
